<h2 mat-dialog-title class="dialog-header">
    <span>Login</span>
    <span class="spacer"></span>
</h2>

<form [formGroup]="loginForm" (ngSubmit)="submit()" mat-dialog-content>
    <mat-form-field class="w-full">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
    </mat-form-field>

    @if (!preselectedType) {
    <mat-form-field class="w-full">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type">
            <mat-option value="stock">Stock</mat-option>
            <mat-option value="customer">Customer</mat-option>
        </mat-select>
    </mat-form-field>
    }

    <app-email-login-field
        [control]="loginForm.controls.email"
        appearance="fill"
        (loginInfoChange)="onLoginInfoChange($event)">
    </app-email-login-field>

    <mat-form-field class="w-full">
        <mat-label>Proxy Country (optional)</mat-label>
        <mat-select formControlName="country">
            <mat-option value="">Any</mat-option>
            @for (country of countries; track country.code) {
            <mat-option [value]="country.code">{{ country.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <div class="flex justify-end gap-2 mt-4" mat-dialog-actions>
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="loginForm.invalid || loginForm.disabled || !loginInfo"
            type="submit">
            Create
        </button>
    </div>
</form>
